import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import Switch from '@material-ui/core/Switch';
import SelectZoneContainer from './SelectZoneContainer'
import SelectScissorsContainer from './SelectScissorsContainer';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import { productionOrderStates as state } from '../../../../Config/productionOrderStates'
import AlertDialog from '../../../Shared/Dialogs/AlertDialog'
import DeleteDialog from '../../../Shared/Dialogs/DeleteDialog';
import { dataService } from '../../../../Services/data.service'
import { toast } from 'react-toastify';
import { scissorTypes } from '../../../../Config/scissorStates'
import StartOrderDialog from '../../../Shared/Dialogs/StartOrderDialog';
import OrderLengthDialog from '../../../Shared/Dialogs/OrderLengthDialog';
import { useTranslation } from 'react-i18next';
import { haveSameBOMIn } from '../../../../Helpers/OrderInfoHelper';
import UnMatchingBOMDialog from '../../../Shared/Dialogs/UnMatchingBOMDialog';
import { findInCollectionById } from '../../../../Helpers/generalHelper';

export default function AddOrderToZonesDrawer(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const [multipleOrders, setMultipleOrders] = useState(true)
    const [selectedZones, setSelectedZones] = useState([])
    const [runningOrPausedDialogOpen, setRunningOrPausedDialogOpen] = useState(false)
    const [startOrderDialogOpen, setStartOrderDialogOpen] = useState(false)
    const [orderLengthDialogOpen, setOrderLengthDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)
    const [upperScissorStatus, setUpperScissorStatus] = useState(null)
    const [lowerScissorStatus, setLowerScissorStatus] = useState(null)
    const [startProductionOrder, setStartProductionOrder] = useState(false)
    const [orderStringList, setOrderStringList] = useState([])
    const [unMatchingBOMDialogOpen, setUnMatchingBOMDialogOpen] = useState(false)
    const [deleteOrderFromZoneDialogOpen, setDeleteOrderFromZoneDialogOpen] = useState(false)
    const [orderToRemoveFromZone, setOrderToRemoveFromZone] = useState(null)

    useEffect(() => {

        dataService.getMachinesWithScissorStatusInfo().then(workstationsWithScissorStatusses => {

            let workstation = workstationsWithScissorStatusses.find(x => x.id === props.productionOrder.machineIdPlanned)
            let upperStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
            let lowerStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)
            setUpperScissorStatus(upperStatus)
            setLowerScissorStatus(lowerStatus)

        }).catch((error) => { toast.error(error, { position: "top-center" }) })

    }, [props.productionOrder, props.orderRefresh]);

    function switchMultipleOrders() {
        setMultipleOrders(!multipleOrders)
    }

    function setZones(zone) {
        let tempZones = selectedZones.slice()
        if (tempZones.some(x => x.zone === zone.zone)) {
            let index = tempZones.indexOf(tempZones.find(x => x.zone === zone.zone))
            tempZones.splice(index, 1)
        }
        else {
            tempZones.push(zone)
            tempZones.find(x => x.zone === zone.zone).orderId = props.productionOrder.id
            tempZones.find(x => x.zone === zone.zone).orderLineId = props.productionOrder.orderLineId
            tempZones.find(x => x.zone === zone.zone).orderRef = props.productionOrder.reference
        }

        setSelectedZones(tempZones)
    }

    function switchScissor(zone) {
        let tempZones = Object.assign([], selectedZones)
        if (tempZones.find(x => x.zone === zone.zone).scissor === 1) {
            tempZones.find(x => x.zone === zone.zone).scissor = 0
        }
        else {
            tempZones.find(x => x.zone === zone.zone).scissor = 1
        }
        tempZones.find(x => x.zone === zone.zone).orderId = props.productionOrder.id
        tempZones.find(x => x.zone === zone.zone).orderLineId = props.productionOrder.orderLineId
        tempZones.find(x => x.zone === zone.zone).orderRef = props.productionOrder.reference

        setSelectedZones(tempZones)
    }

    const startOrder = (startProduction) => {

        if (startProductionOrder || startProduction === true) {
            let totalSelectedZones = selectedZones.concat(props.zonesWithScissors.filter(x => x.used))
            var i;
            let orderList = []

            if (!multipleOrders) {
                orderList.push('Order ' + props.productionOrder.reference)
            }
            else {
                for (i = 0; i < totalSelectedZones.length; i++) {
                    let scissor = ""
                    if (totalSelectedZones[i].scissor === 1) {
                        scissor = scissorTypes.UPPER.toLowerCase()
                    }
                    else {
                        scissor = scissorTypes.LOWER.toLowerCase()
                    }

                    if (!isRunningOrPaused(totalSelectedZones[i].orderId)) {
                        if (props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.TABLE)) {
                            orderList.push('Order' + totalSelectedZones[i].orderRef + t(" in zone  ") + totalSelectedZones[i].zone)
                        } else {
                            orderList.push('Order ' + totalSelectedZones[i].orderRef + t(" on  ") + t(scissor) + t(" scissor from zone ") + totalSelectedZones[i].zone)
                        }
                    }
                }
            }

            setOrderStringList(orderList)
            setOrderLengthDialogOpen(false)
            setStartOrderDialogOpen(true)
        }
        else {
            setOrderLengthDialogOpen(false)
            addOrder(false)
        }
    }



    const checkLengthOfProductionOrders = (startProduction) => {
        if (multipleOrders && selectedZones.length > 0) {

            let totalSelectedZones = selectedZones.concat(props.zonesWithScissors.filter(x => x.used)).sort((a, b) => b.used - a.used)
            let ordersOnUpperScissor = []
            let ordersOnLowerScissor = []
            let orderToCheck = null
            var i;
            for (i = 0; i < totalSelectedZones.length; i++) {
                if (totalSelectedZones[i].scissor === 1) {
                    ordersOnUpperScissor.push(findInCollectionById(props.productionOrders, totalSelectedZones[i].orderId))
                }
                else {
                    ordersOnLowerScissor.push(findInCollectionById(props.productionOrders, totalSelectedZones[i].orderId))
                }
            }

            var y;
            let upperLength = 0
            for (y = 0; y < ordersOnUpperScissor.length; y++) {

                if (y === 0) {
                    upperLength = JSON.parse(ordersOnUpperScissor[y].bomOut[0].productMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length.Value
                    orderToCheck = ordersOnUpperScissor[y]
                }

                if (JSON.parse(ordersOnUpperScissor[y].bomOut[0].productMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length.Value !== upperLength) {
                    let usedZonesOnUpperScissor = props.zonesWithScissors.filter(x => x.used && x.scissor === 1)
                    if (!zoneHasOrder(usedZonesOnUpperScissor, ordersOnUpperScissor[y].id)) {
                        setStartProductionOrder(startProduction)
                        setDialogContext(t("The length of order ") + ordersOnUpperScissor[y].reference + t(" does not match the length of order ") + orderToCheck.reference + t(" on the upper scissors!"))
                        setOrderLengthDialogOpen(true)
                        return
                    }
                }
            }

            var z;
            let lowerLength = 0
            for (z = 0; z < ordersOnLowerScissor.length; z++) {

                if (z === 0) {
                    lowerLength = JSON.parse(ordersOnLowerScissor[z].bomOut[0].productMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length.Value
                    orderToCheck = ordersOnLowerScissor[z]
                }

                if (JSON.parse(ordersOnLowerScissor[z].bomOut[0].productMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length.Value !== lowerLength) {
                    let usedZonesOnLowerScissor = props.zonesWithScissors.filter(x => x.used && x.scissor === 0)
                    if (!zoneHasOrder(usedZonesOnLowerScissor, ordersOnLowerScissor[z].id)) {
                        setStartProductionOrder(startProduction)
                        setDialogContext(t("The length of order ") + ordersOnLowerScissor[z].reference + t(" does not match the length of order ") + orderToCheck.reference + t(" on the lower scissors!"))
                        setOrderLengthDialogOpen(true)
                        return;
                    }
                }
            }
        }
        startOrder(startProduction)
    }

    const zoneHasOrder = (zones, orderId) => {
        for (const item of zones) {
            if (item.orderId === orderId) {
                return true
            }
        }

        return false
    }

    const findZoneByName = (zones, name) => {
        for (const item of zones) {
            if (item.name === name) {
                return item
            }
        }
    }

    const addOrStartOrderAfterIgnoreUnMatchingBOMIn = () => {
        addOrder(startProductionOrder, true)
        setUnMatchingBOMDialogOpen(false)
    }

    function addOrder(startProduction, ignoreNotMatchingBOMIns) {
        //Check for running or paused orders 
        var i;
        let unMatchingBOMIn = false
        for (i = 0; i < props.productionOrders.length; i++) {
            if (props.productionOrders[i].productionOrderStatus === state.RUNNING || props.productionOrders[i].productionOrderStatus === state.PAUSED) {

                if (!haveSameBOMIn(props.productionOrder, props.productionOrders[i])) {
                    if (!ignoreNotMatchingBOMIns) {
                        unMatchingBOMIn = true;
                    }
                }


            }
        }

        if (unMatchingBOMIn) {
            setStartProductionOrder(startProduction)
            setDialogTitle(t("Attention!"))
            setDialogContext("Order " + props.productionOrder.reference + t(" needs different materials than the running order(s)"))
            setUnMatchingBOMDialogOpen(true)
            return
        }

        if (multipleOrders) {
            let metaData = [{
                MetaDataType: 1,
                Version: 1,
                MetaData: [{
                    UsedZones: []
                }]
            }]

            let totalSelectedZones = selectedZones.concat(props.zonesWithScissors.filter(x => x.used && x.orderId === props.productionOrder.id))
            var o;
            for (o = 0; o < totalSelectedZones.length; o++) {
                let scissor = ""

                if (props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.TABLE)) {
                    scissor = scissorTypes.TABLE
                } else {
                    if (totalSelectedZones[o].scissor === 1) {
                        scissor = scissorTypes.UPPER
                    }
                    else {
                        scissor = scissorTypes.LOWER
                    }
                }

                let zones = props.zones.filter(y => y.code.includes(scissor) && y.code.includes(String(props.productionOrder.machinePlannedCode)))
                let zone = findZoneByName(zones, totalSelectedZones[o].zone)
                metaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.push({
                    ZoneId: zone.id,
                    StartedOn: null,
                    FinishedOn: null
                })
            }

            dataService.updateZones(JSON.stringify(metaData), props.productionOrder.id, props.productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: "top-center" }) })

        }

        if (!startProduction) {
            props.refreshOrder()
        }

        selectLine(props.productionOrder.machineIdPlanned, props.productionOrder.id)

        if (startProduction) {
            startPlannedProductionOrders()
        }

        setSelectedZones([])
    }

    function startPlannedProductionOrders() {
        let tempZones = Object.assign([], props.zonesWithScissors.filter(x => x.used))
        if (!multipleOrders) {
            dataService.startProductionOrderLine(props.productionOrder.orderLineId, props.workstation.selectedWorkstation, props.user.packer).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) })
            cleanRemainingOrdersInZones(tempZones)
        }
        else {
            var i;
            for (i = 0; i < tempZones.length; i++) {
                if (!isRunningOrPaused(tempZones[i].orderId)) {
                    dataService.startProductionOrderLine(tempZones[i].orderLineId, props.workstation.selectedWorkstation, props.user.packer).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) })
                }
            }
            var y;
            for (y = 0; y < selectedZones.length; y++) {
                dataService.startProductionOrderLine(selectedZones[y].orderLineId, props.workstation.selectedWorkstation, props.user.packer).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) })
            }
        }
        setStartOrderDialogOpen(false)
        props.openDrawer(false)
    }

    function cleanRemainingOrdersInZones(zones) {
        //Delete orders added to zones 

        var i;
        var zonesToRemove = []
        for (i = 0; i < zones.length; i++) {

            let zoneToRemove = { zone: zones[i].zone, scissor: zones[i].scissor, orderId: zones[i].orderId }
            zonesToRemove.push(zoneToRemove)
        }

        removeAllOrdersFromAllZones(zonesToRemove)
    }

    const removeOrderFromZone = (object) => {
        let orderId = object.orderId;
        let scissor = object.scissor;
        let zone = object.zone;

        dataService.getOrderDetailsByOrderId(orderId).then(productionOrder => {

            let scissorPosition = scissorTypes.UPPER;
            if (scissor === 0) {
                scissorPosition = scissorTypes.LOWER;
            }
            let allZones = props.zones.filter(x => x.code.includes(scissorPosition));
            let bowMetaData = JSON.parse(productionOrder.bowMetaData)

            let indexOfZone = bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.findIndex(x => x.ZoneId === allZones.find(y => y.name === zone).id)
            bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.splice(indexOfZone, 1)
            if (bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.length === 0) {
                if (productionOrder.productionOrderStatus === state.RUNNING) {
                    dataService.stopProductionOrderLine(productionOrder.orderLineId, productionOrder.machineId, null, null, props.user.packer).then().catch((error) => { toast.error(error, { position: "top-center" }) })
                }
                dataService.updateZones(null, orderId, productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: "top-center" }) })
            }
            else {
                dataService.updateZones(JSON.stringify(bowMetaData), orderId, productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: "top-center" }) })
            }

            setDeleteOrderFromZoneDialogOpen(false)
            props.refreshOrder()
            selectLine(productionOrder.machineIdPlanned, indexOfZone)

        }).catch((error) => { toast.error(error, { position: "top-center" }) })
    }

    const openDeleteOrderFromZoneDialog = (zone, scissor, orderRef, orderId) => {
        let scissorPosition = ""
        if (scissor === 1) {
            scissorPosition = "upper"
        }
        else {
            scissorPosition = "lower"
        }
        setOrderToRemoveFromZone({ zone: zone, scissor: scissor, orderId: orderId })
        setDialogTitle("Delete")
        setDialogContext(t("Are you sure deleting order ") + orderRef + t(" from zone ") + zone + t(" on the ") + t(scissorPosition) + t(" scissor?"))
        setDeleteOrderFromZoneDialogOpen(true)
    }

    const hasZonesWithOrder = (zonesByOrderArray, orderId) => {
        for (const item of zonesByOrderArray) {
            if (zoneHasOrder(item, orderId)) {
                return true
            }
        }
        return false
    }

    const findZoneByOrderId = (zones, orderId) => {
        for (const item of zones) {
            if (item.orderId === orderId) {
                return item
            }
        }
    }

    const findZoneArrayByOrderId = (zones, orderId) => {
        for (const item of zones) {
            if (findZoneByOrderId(item, orderId)) {
                return item
            }
        }
    }

    const removeAllOrdersFromAllZones = (zoneArray) => {
        var zonesByOrderArray = []
        var i;
        for (i = 0; i < zoneArray.length; i++) {

            if (hasZonesWithOrder(zonesByOrderArray, zoneArray[i].orderId)) {
                var index = zonesByOrderArray.indexOf(findZoneArrayByOrderId(zonesByOrderArray, zoneArray[i].orderId))
                zonesByOrderArray[index].push(zoneArray[i])
            }
            else {
                zonesByOrderArray.push([zoneArray[i]])
            }
        }

        var y;
        for (y = 0; y < zonesByOrderArray.length; y++) {
            // eslint-disable-next-line
            dataService.getOrderDetailsByOrderId(zonesByOrderArray[y][0].orderId).then(productionOrder => {
                let bowMetaData = JSON.parse(productionOrder.bowMetaData)
                var index = zonesByOrderArray.findIndex(z => z.find(x => x.orderId === productionOrder.id))
                var z;
                for (z = 0; z < zonesByOrderArray[index].length; z++) {

                    let scissor = zonesByOrderArray[index][z].scissor
                    let scissorPosition = scissorTypes.UPPER;
                    if (scissor === 0) {
                        scissorPosition = scissorTypes.LOWER;
                    }
                    let allZones = props.zones.filter(x => x.code.includes(scissorPosition));
                    // eslint-disable-next-line
                    let indexOfZone = bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.findIndex(x => x.ZoneId === allZones.find(y => y.name === zonesByOrderArray[index][z].zone).id)

                    bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.splice(indexOfZone, 1)
                }

                if (bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.length === 0) {
                    dataService.updateZones(null, productionOrder.id, productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: "top-center" }) })
                }
                else {
                    dataService.updateZones(JSON.stringify(bowMetaData), productionOrder.id, productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: "top-center" }) })
                }

                props.refreshOrder()
                selectLine(productionOrder.machineIdPlanned)

            }).catch((error) => { toast.error(error, { position: "top-center" }) })
        }
    }

    const selectLine = (line, indexOfZoneToBeDeleted) => {

        let bowMetaData = JSON.parse(props.productionOrder.bowMetaData)
        if (bowMetaData) {
            let metaData = bowMetaData.find(x => x.MetaDataType === 1).MetaData[0]

            if (metaData.UsedZones.length > 0) {

                if (selectedZones.length > 0) {
                    if (selectedZones[0].zone === props.workstation.selectedZone) {
                        props.actions.setSelectedZone(null)
                    }
                    setTimeout(() => props.actions.setSelectedZone(selectedZones[0].zone), 1000)
                }
                else {
                    metaData.UsedZones.splice(indexOfZoneToBeDeleted, 1)
                    if (metaData.UsedZones.length === 0) {
                        props.actions.setSelectedZone(null)
                    } else {
                        let sortedZones = metaData.UsedZones.sort((a, b) => a.ZoneId - b.ZoneId)
                        if (props.zones.find(x => x.id === sortedZones[0].ZoneId).name === props.workstation.selectedZone) {
                            props.actions.setSelectedZone(null)
                        }

                        setTimeout(() => props.actions.setSelectedZone(props.zones.find(x => x.id === sortedZones[0].ZoneId).name), 1000)
                    }
                }
                props.actions.setSelectedWorkstation(line)
            }
        }
        else {
            if (selectedZones.length > 0) {

                if (selectedZones[0].zone === props.workstation.selectedZone) {
                    props.actions.setSelectedZone(null)
                }

                setTimeout(() => props.actions.setSelectedZone(selectedZones[0].zone), 1000)
            }
            else {
                props.actions.setSelectedZone(null)
                props.actions.setSelectedWorkstation(line)
            }
        }
    }

    function closeRunningOrPausedDialog() {
        setRunningOrPausedDialogOpen(false)
    }

    function closeStartOrderDialog() {
        setStartOrderDialogOpen(false)
    }

    function closeOrderLengthDialog() {
        setStartProductionOrder(false)
        setOrderLengthDialogOpen(false)
    }

    function closeUnMatchingBomDialog() {
        setUnMatchingBOMDialogOpen(false)
    }

    function isRunningOrPaused(orderId) {
        let order = props.productionOrders.find(x => x.id === orderId)
        if (order.productionOrderStatus === state.RUNNING) {

            return true
        }
        else {
            return false
        }
    }

    function hasPlannedOrders(zones) {
        let noOrdersOnAllzones = true
        for (var zone of zones) {
            if (zone.orderId !== null && zone.used) {
                noOrdersOnAllzones = false
                if (!isRunningOrPaused(zone.orderId)) {
                    return true
                }
            }
        }

        if (selectedZones.length > 0) {
            return true
        }

        if (noOrdersOnAllzones) {
            return true
        }

        return false
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>Order status</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}>
                        <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                    </Button>
                </div>
            </div>
            <div className={classes.body}>
                <div className={classes.switchContainer}>
                    <Switch className={classes.multipleOrdersSwitch}
                        checked={multipleOrders}
                        onChange={switchMultipleOrders}
                        name="multipleOrders"
                        disabled={props.productionOrders.some(x => x.productionOrderStatus === state.RUNNING || x.productionOrderStatus === state.PAUSED) && props.zonesWithScissors.some(x => x.used)}
                    />
                    <div className={classes.switchText}>{t("Run multiple orders on this machine")}</div>
                </div>
                {multipleOrders && !upperScissorStatus && !lowerScissorStatus ?
                    <React.Fragment>
                        <SelectZoneContainer zonesWithScissors={props.zonesWithScissors} {...props} productionOrder={props.productionOrder} selectedZones={selectedZones} setZones={setZones}></SelectZoneContainer>
                    </React.Fragment> : <React.Fragment></React.Fragment>}
                {multipleOrders && upperScissorStatus && lowerScissorStatus ? <React.Fragment>
                    <SelectZoneContainer zonesWithScissors={props.zonesWithScissors} {...props} productionOrder={props.productionOrder} selectedZones={selectedZones} setZones={setZones}></SelectZoneContainer>
                    <SelectScissorsContainer zonesWithScissors={props.zonesWithScissors} upperScissorStatus={upperScissorStatus} lowerScissorStatus={lowerScissorStatus} {...props} productionOrder={props.productionOrder} selectedZones={selectedZones} switchScissor={switchScissor}></SelectScissorsContainer>
                    <div className={classes.addOrder}>{selectedZones.length !== 0 ? <button className={classes.addOrderButton} onClick={() => checkLengthOfProductionOrders(false)}>{t("ADD ORDER")}</button> : <React.Fragment></React.Fragment>}</div>
                </React.Fragment> :
                    <React.Fragment></React.Fragment>}
                <div className={classes.startProduction}>{!props.zonesWithScissors.some(x => x.used) && selectedZones.length === 0 && multipleOrders ? <React.Fragment></React.Fragment> : <button className={classes.startProductionButton} style={{ opacity: !hasPlannedOrders(props.zonesWithScissors) ? "0.5" : "1" }} disabled={!hasPlannedOrders(props.zonesWithScissors)} onClick={() => checkLengthOfProductionOrders(true)}> <PlayArrowRoundedIcon className={classes.start}></PlayArrowRoundedIcon> <div className={classes.startProductionText}>{t("START PRODUCTION")}</div></button>}</div>
                {multipleOrders ? <div className={classes.usedZoneList}>
                    {props.zonesWithScissors.filter(x => x.used).map(z => {
                        return (
                            <div className={classes.usedZone} key={z.zone}>
                                {"Zone " + z.zone + ": " + z.orderRef + " "}
                                {!isRunningOrPaused(z.orderId) && <button className={classes.removeOrderFromZoneButton} onClick={() => openDeleteOrderFromZoneDialog(z.zone, z.scissor, z.orderRef, z.orderId)}>{" X"}</button>}
                            </div>)
                    })}
                </div> : <React.Fragment></React.Fragment>}
                <OrderLengthDialog {...props} dialogOpen={orderLengthDialogOpen} closeDialog={closeOrderLengthDialog} action={() => startOrder} dialogContext={dialogContext}></OrderLengthDialog>
                <UnMatchingBOMDialog {...props} dialogOpen={unMatchingBOMDialogOpen} closeDialog={closeUnMatchingBomDialog} action={() => addOrStartOrderAfterIgnoreUnMatchingBOMIn} dialogContext={dialogContext} dialogTitle={dialogTitle}></UnMatchingBOMDialog>
                <StartOrderDialog {...props} dialogOpen={startOrderDialogOpen} closeDialog={closeStartOrderDialog} orderList={orderStringList} action={() => addOrder} dialogTitle={dialogTitle} dialogContext={dialogContext}></StartOrderDialog>
                <DeleteDialog dialogOpen={deleteOrderFromZoneDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setDeleteOrderFromZoneDialogOpen(false)} action={() => removeOrderFromZone(orderToRemoveFromZone)}></DeleteDialog>
                <AlertDialog {...props} dialogOpen={runningOrPausedDialogOpen} action={closeRunningOrPausedDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></AlertDialog>
            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        paddingLeft: "15px",
        paddingRight: "10px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "auto",
        minWidth: "380px"
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        display: "inline-block",
        verticalAlign: "top"
    },
    title: {
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px",
        paddingLeft: "8px",
        display: "inline-block",
        boxSizing: "border-box"
    },

    header: {
        width: "100%",
        height: "auto",
        marginBottom: "20px"
    },
    switchText: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        paddingTop: "10px"
    },
    multipleOrdersSwitch: {
        float: "left",
        height: "48px",
        width: "65px",
        '& .MuiSwitch-track': {
            backgroundColor: "#00000029",
            opacity: "1",
            position: "relative",
            bottom: "5px",
            right: "4px",
            borderRadius: "15px"
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: "#5CC958",
            opacity: "1",
            position: "relative",
            bottom: "5px",
            right: "2px",
            borderRadius: "15px"
        }
    },
    switchContainer: {
        width: "100%",
        height: "50px"
    },
    addOrder: {
        width: "100%",
        textAlign: "center",
        marginBottom: "10px",
        marginTop: "30px"
    },
    addOrderButton: {
        width: "200px",
        height: "40px",
        borderRadius: "5px",
        outline: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        textAlign: "center",
        backgroundColor: FlagstoneTheme.palette.primary.main
    },
    startProductionButton: {
        width: "200px",
        height: "40px",
        borderRadius: "5px",
        outline: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        textAlign: "center",
        backgroundColor: "#5CC958",
    },
    startProduction: {
        width: "100%",
        textAlign: "center"
    },
    start: {
        color: "white",
        height: "30px",
        width: "30px",
        float: "left"
    },
    startProductionText: {
        float: "left",
        paddingTop: "6px",
        marginLeft: "8px"
    },
    removeOrderFromZoneButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        backgroundColor: "rgb(1,1,1,0)",
        fontWeight: 'bold',
        marginBottom: "5px"
    },
    usedZone: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        width: "100%",
        textAlign: "center",
        marginBottom: "5px"
    },
    usedZoneList: {
        marginTop: "50px"

    }
}));